import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { dispatchCustomEvent } from '../utils/customEvents';

export const usePageEvent = () => {
  const location = useLocation();
  useEffect(() => {
    dispatchCustomEvent('ccb:page', {
      location:
        location.pathname + (location.search ? '?' + location.search : ''),
    });
  }, [location]);
};
